<template>
  <nav>
  <v-app-bar
    app
    dense
    color="#339966"
    height="42"
    dark>
    <div @click="navigate(0)" style="display: inline-flex; align-items: center; cursor: pointer;">
        <v-img
            alt="EGPAF logo"
            contain
            class="pa-0 ml-0 mr-2"
            src="../assets/coat-of-arms.png"
            transition="scale-transition"
            height="32px"
            width="32px"
            style="border-radius: 50%; cursor: pointer;"
        />
        <span class="white--text large font-weight-medium pa-0 ma-0 caption" style="cursor: pointer;">MAP</span>
    </div>
    <v-spacer/>
    <span @click="navigate(1)" class="white--text large font-weight-medium caption" style="cursor: pointer;">Sign In</span>
  </v-app-bar>
  </nav>
</template>

<script>

export default {
  name: 'App',
  props: {
    source: String
  },
  data: () => {
    return {
    }
  },
  methods: {
    navigate (index) {
      const currentRoute = this.$router.currentRoute.path
      switch (index) {
        case 0:
          if (currentRoute !== '/') {
            this.$router.push('/')
          }
          break
        default:
          if (currentRoute !== '/login') {
            this.$router.push('/login')
          }
        // default:
          // this.$router.push('/login')
      }
    }
  },
  mounted: function () {
  },
  watch: {
  }
}
</script>
<style scoped>
.v-text-field >>> input {
  font-size: 0.80em;
}
.v-text-field >>> label {
  font-size: 0.80em;
}
</style>
